module.exports = __webpack_public_path__ + "img/green.6e018eed.png";